import { useEffect, useState } from 'react';
import { loadHomePersonId } from './homePersonStorage';

/** Reactive home person id (DNA / chromosome subject); updates when changed on Chromosome Painter page. */
export function useHomePersonId(): string {
  const [id, setId] = useState(loadHomePersonId);
  useEffect(() => {
    const sync = () => setId(loadHomePersonId());
    window.addEventListener('geneology-home-person-changed', sync);
    return () => window.removeEventListener('geneology-home-person-changed', sync);
  }, []);
  return id;
}
